import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fdf33d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-info"
}
const _hoisted_2 = { class: "download-links" }
const _hoisted_3 = { class: "app-graphic" }
const _hoisted_4 = { class: "device-container" }
const _hoisted_5 = { class: "device back" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "device front" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "app-info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "logo icon-cmd" }, null, -1))
const _hoisted_11 = { class: "download-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicLogo = _resolveComponent("ClinicLogo")!
  const _component_AppBadges = _resolveComponent("AppBadges")!
  const _component_DeviceFrame = _resolveComponent("DeviceFrame")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-download-frame", [_ctx.layout]])
  }, [
    (_ctx.layout === _ctx.AppDownloadLayout.STANDARD)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showLogo)
            ? (_openBlock(), _createBlock(_component_ClinicLogo, {
                key: 0,
                class: "branded-logo",
                "icon-font-size": "96px",
                diameter: "124px",
                "border-width": "0px"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h1", {
            class: _normalizeClass(_ctx.headerClassList)
          }, _toDisplayString(_ctx.headerText), 3),
          _createElementVNode("p", null, _toDisplayString(_ctx.messageText), 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_AppBadges)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DeviceFrame, {
            deviceType: "phone",
            width: _ctx.backDeviceWith,
            height: _ctx.backDeviceHeight,
            "no-border": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.iphoneBackScreen,
                alt: "Phone Telehealth"
              }, null, 8, _hoisted_6)
            ]),
            _: 1
          }, 8, ["width", "height"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_DeviceFrame, {
            deviceType: "phone",
            width: _ctx.frontDeviceWidth,
            height: _ctx.frontDeviceHeight,
            "no-border": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.iphoneFrontScreen,
                alt: "Phone Homescreen"
              }, null, 8, _hoisted_8)
            ]),
            _: 1
          }, 8, ["width", "height"])
        ])
      ])
    ]),
    (_ctx.layout === _ctx.AppDownloadLayout.REVERSED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("h1", {
            class: _normalizeClass(_ctx.headerClassList)
          }, _toDisplayString(_ctx.headerText), 3),
          _createElementVNode("p", null, _toDisplayString(_ctx.messageText), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_AppBadges, { "blue-badges": "" })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}